const MAX_POPOVER_HEIGHT = 250;
const MAX_POPOVER_WIDTH = 400;
const POPOVER_BOTTOM_OFFSET = 20; // distance between bottom of chart and popover
const POPOVER_BAR_OFFSET = 10; // distance chart bar and popover
export interface Position {
  left?: string;
  right?: string;
  top?: string;
  bottom?: string;
}

/**
 * calculate the position for a popover with +dimensions+ placed next to a bar.
 * @param barElement what to position the popover next to
 * @param chartElement popover can't go past the bottom
 * @param viewerElement popover can't cross the the left or right boundary
 * @param dimensions height, width, and positioning constraints for the popover
 * @param dimensions.height height to use for positioning
 * @param dimensions.width width to use for positioning
 * @param dimensions.xOffset how far away to place it from the barElement
 * @param dimensions.bottomOffset how far away to place it from the bottom of the chartElement
 */
export function calculatePopoverPosition({
  barElement,
  viewerElement,
  dimensions = {
    height: MAX_POPOVER_HEIGHT,
    width: MAX_POPOVER_WIDTH,
    bottomOffset: POPOVER_BOTTOM_OFFSET,
    xOffset: POPOVER_BAR_OFFSET,
  },
}: {
  barElement: HTMLElement;
  viewerElement: HTMLElement;
  dimensions?: {
    height: number;
    width: number;
    xOffset: number;
    bottomOffset: number;
  };
}): Position {
  const styles: Position = {};

  const barRect = barElement.getBoundingClientRect();
  const viewerRect = viewerElement.getBoundingClientRect();
  const top = barRect.top - viewerRect.top;
  const left = barRect.right - viewerRect.left + dimensions.xOffset;

  const right = -(barRect.left - viewerRect.right - dimensions.xOffset);

  const wouldGoOffRightSide = barRect.right + dimensions.width > window.innerWidth;
  const wouldGoOffLeftSide = barRect.left - dimensions.width < 0;

  // don't let popover overflow right, or go off the right side of the screen
  // but don't go off on the left side no matter what
  if (wouldGoOffRightSide && !wouldGoOffLeftSide) {
    styles.right = `${right}px`;
  } else {
    styles.left = `${left}px`;
  }

  // TODO(sam) figure out a good way to get correct bottom offset if it will be positioned offscreen,
  // we can't simply place it bottom due to things like data tables, etc making bottom not the bottom we're expecting
  styles.top = `${top}px`;

  return styles;
}
